export default class Scanner {
    constructor() {
        this.timeout = 100;
        this.code = "";
        this.cancelButton = "";
        this.alphanum = Array.from({ length: 37 }, (x, i) => i);
        this.dash = [8, 13, 18, 23];
        this.alphanum = this.alphanum.filter(x => !this.dash.includes(x));
        this.checkInOutUrl = document.querySelector("#scan-qr-code-button")
            ? document.querySelector("#scan-qr-code-button").dataset.checkInOutUrl : "";
        this.event = {
            config: null,
            timeout: null,
        };
        this.index = 0;

        this.handleScanner = this.handleScanner.bind(this);
        this.dispatch = this.dispatch.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        const links = document.querySelectorAll(".scan-qr-code");
        links.forEach((link) => {
            link.addEventListener("click", this.handleScanner);
        });

        document.addEventListener("unbindScannerKeydown", () => {
            document.querySelector("body").removeEventListener("keydown", this.handleKeydown);
        });
        document.addEventListener("bindScannerKeydown", () => {
            document.querySelector("body").addEventListener("keydown", this.handleKeydown);
        });
    }

    handleScanner() {
        document.dispatchEvent(new Event("bindCancelButton"));

        document.querySelector("body").addEventListener("keydown", this.handleKeydown);

        document.dispatchEvent(new Event("togglePopupScanner"));
    }

    addTimeout() {
        this.event.timeout = setTimeout(this.dispatch, this.timeout);
    }

    removeTimeout() {
        if (this.event.timeout !== null) {
            clearTimeout(this.event.timeout);
            this.event.timeout = null;
        }
    }

    reset() {
        this.removeTimeout();
        this.code = "";
        this.event = {
            config: null,
            timeout: null,
        };
        this.index = 0;
    }

    dispatch() {
        this.event.config.target.value += this.code;
        if (this.index > 1) {
            document.dispatchEvent(new Event("toggleLoader"));

            const updatePopupEvent = new Event("updateIssuePopup");
            document.dispatchEvent(updatePopupEvent);
        }

        this.reset();
    }

    doCheckInOut() {
        const url = this.checkInOutUrl.replace("_tourGroupId", this.code);
        document.dispatchEvent(new Event("toggleLoader"));

        fetch(url, {
            credentials: "include",
        }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            } else {
                return response.text();
            }
        }).then((text) => {
            const updatePopupEvent = new Event("updatePopupContent");
            updatePopupEvent.content = text;
            document.dispatchEvent(updatePopupEvent);
        }).catch(() => {
            const updatePopupEvent = new Event("updateIssuePopup");
            document.dispatchEvent(updatePopupEvent);
        });

        this.reset();
    }

    handleKeydown(event) {
        event.preventDefault();
        this.event.config = event;
        // code attribute is the physical keyboard, don't take layout in account.
        this.keyDown = this.getPhysicalKeyDown(event.code);

        this.removeTimeout();
        this.addTimeout();
        // Check matching UUID
        if (this.alphanum.includes(this.index)) {
            if (!this.keyDown.match(/[a-z0-9]/)) {
                this.dispatch();

                return;
            }
            this.index += 1;
        } else if (this.dash.includes(this.index)) {
            if (!this.keyDown.match(/[-]/)) {
                this.dispatch();

                return;
            }
            this.index += 1;
        } else {
            this.reset();
        }

        this.code += this.keyDown;

        if (this.index === 36) {
            this.doCheckInOut();
            this.reset();
        }
    }

    getPhysicalKeyDown(code) {
        if (code.match(/Key|Digit/)) {
            return code.slice(-1).toLowerCase();
        }
        if (code.match(/Minus/)) {
            return "-";
        }

        return "";
    }
}
